import React from "react";
import DesktopVersion from "./DesktopVersion";
import MobileVersion from "./MobileVersion";
import { headers, featuresList } from "./data";

function FeatureDataTable() {
  return (
    <section
      className="relative bg-gradient-to-b from-gray-900 via-gray-800 to-black py-20 sm:py-24 lg:py-32"
      id="features"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/30 via-purple-900/20 to-transparent" />
        <div className="absolute left-1/4 top-0 size-96 rounded-full bg-blue-500/20 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 size-96 rounded-full bg-purple-500/20 blur-3xl" />
        {/* Additional atmospheric lighting */}
        <div className="absolute right-1/3 top-1/3 size-64 rounded-full bg-indigo-500/15 blur-2xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <div className="mb-6 inline-flex items-center rounded-full border border-blue-400/40 bg-blue-500/30 px-6 py-2 shadow-lg backdrop-blur-sm">
            <span className="text-sm font-semibold uppercase tracking-wide text-blue-200">Feature Comparison</span>
          </div>
          <h2 className="mb-6 text-4xl font-bold text-white sm:text-5xl lg:text-6xl">
            Why Choose{" "}
            <span className="bg-gradient-to-r from-blue-300 to-purple-300 bg-clip-text text-transparent">Fundview</span>
            ?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-xl leading-relaxed text-gray-300">
            See how Fundview&#39;s comprehensive deal flow platform compares to traditional CRM solutions. We&#39;re
            built specifically for commercial real estate finance professionals.
          </p>
        </div>

        {/* Feature Comparison Table */}
        <div className="mt-16">
          <DesktopVersion headers={headers} featuresList={featuresList} />
          <MobileVersion featuresList={featuresList} />
        </div>

        {/* Enhanced Call-to-Action */}
        <div className="mt-20 text-center">
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 p-12 shadow-2xl">
            {/* Background Effects */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600/90 via-purple-600/90 to-indigo-600/90" />
            <div className="absolute left-0 top-0 size-full">
              <div className="absolute left-1/4 top-0 size-32 animate-pulse rounded-full bg-white/10 blur-2xl" />
              <div className="absolute bottom-0 right-1/4 size-40 animate-pulse rounded-full bg-white/5 blur-3xl delay-1000" />
            </div>

            <div className="relative">
              <h3 className="mb-6 text-3xl font-bold text-white sm:text-4xl">Ready to Transform Your Deal Flow?</h3>
              <p className="mx-auto mb-8 max-w-2xl text-xl text-blue-100">
                Join hundreds of CRE professionals who&#39;ve streamlined their operations with Fundview&#39;s
                cutting-edge platform.
              </p>
              <div className="flex justify-center">
                <a
                  href="#signup"
                  className="group relative inline-flex items-center justify-center overflow-hidden rounded-xl bg-white px-12 py-4 text-lg font-bold text-gray-900 shadow-xl transition-all duration-300 hover:scale-105 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-600"
                >
                  <span className="relative">Start Free Trial</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-purple-50 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeatureDataTable;
